import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { getAllLeaves } from "../../api/leavesApi"; 
import "../../css/CustomTable.css";

export default function LeaveDetails() {
  const [leaves, setLeaves] = useState([]);

  
    const navigate = useNavigate();

  useEffect(() => {
    fetchLeaves();
  }, []);

  const fetchLeaves = async () => {
    try {
      const data = await getAllLeaves();
      setLeaves(data || []);
    } catch (error) {
      console.error("Error fetching leave details", error);
      setLeaves([]);
    }
  };

  return (
    <div className="container-fluid p-2">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="allowance-heading mb-0">Leave Details</h4>
        <button className="btn btn-secondary btn-sm" onClick={() => navigate(-1)}>
          ← Back
        </button>
      </div>

    <div className="allowance-table-container mb-4">
      <table className="allowance-table">
        <thead>
          <tr>
            <th>Sr</th>
            <th>Leave Code</th>
            <th>Leave Name</th>
            <th>Max Per Year</th>
          </tr>
        </thead>
        <tbody>
          {leaves.length > 0 ? (
            leaves.map((leave, index) => (
              <tr key={leave.leaveCode}>
                <td>{index + 1}</td>
                <td>{leave.leaveCode}</td>
                <td>{leave.leaveName}</td>
                <td>{leave.maxPerYear}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="4" className="text-center">
                No leave details found 🚫
              </td>
            </tr>
          )}
        </tbody>
      </table>
      </div>
    </div>
  );
}
